module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-1800.b8ff2a69.svg";